import React from 'react'
import ModalFormUI from '../../../widgets/form/ModalFormUI'
import InputTextSF from '../../../widgets/form/InputTextSF'
import InputDateUI from '../../../widgets/form/InputDateUI'
import InputSelectSF from '../../../widgets/form/InputSelectSF'

const LoanChequeUpdateModalUI = ({ 
  context, successMsg, errorList, setErrorList, messageList,
  // modes
  updateMode,
  // event handlers
  onSubmit, onCancelClick,
  // form fields
  chequeNumber, onChequeNumberChange, chequeNumberError, setChequeNumberError,
  bounceReason, onBounceReasonChange, bounceReasonError, setBounceReasonError,
  bounceDate, onBounceDateChange, bounceDateError, setBounceDateError,
  bankName, onBankNameChange, bankNameError, setBankNameError,
  branchName, onBranchNameChange, branchNameError, setBranchNameError,
  amount, onAmountChange, amountError, setAmountError,
  closureStatusList,closureStatus, onClosureStatusChange, closureStatusError, setClosureStatusError
}) => {
  return (
    <ModalFormUI
      context={context}
      titleLabel='Update Loan Cheque Bounce'
      buttonLabel='Update'
      cancelLabel='Cancel'
      isOpen={updateMode}
      onRequestClose={onCancelClick}
      successMsg={successMsg}
      errorList={errorList}
      setErrorList={setErrorList}
      onSubmit={onSubmit}
    >
      <InputTextSF type='text' name='chequeNumber' maxLength={20}
        label='Cheque Number'
        value={chequeNumber} onChange={onChequeNumberChange}
        error={chequeNumberError} setError={setChequeNumberError}
        autoFocus={true}
      />
      <InputTextSF type='text' name='bounceReason' maxLength={50}
        label='Bounce Reason'
        value={bounceReason} onChange={onBounceReasonChange}
        error={bounceReasonError} setError={setBounceReasonError}
      />
      <InputDateUI context={context} name='bounceDate'
        messageList={messageList} label='Bounce Date'
        selectedDateISO={bounceDate} onChange={onBounceDateChange}
        error={bounceDateError} setError={setBounceDateError}
      />
      <InputTextSF type='text' name='bankName' maxLength={50}
        label='Bank Name'
        value={bankName} onChange={onBankNameChange}
        error={bankNameError} setError={setBankNameError}
      />
      <InputTextSF type='text' name='branchName' maxLength={50}
        label='Branch Name'
        value={branchName} onChange={onBranchNameChange}
        error={branchNameError} setError={setBranchNameError}
      />
      <InputTextSF type='text' name='amount' maxLength={20}
        label='Amount'
        value={amount} onChange={onAmountChange}
        error={amountError} setError={setAmountError}
      />
      <InputSelectSF
        type='select' name='closureStatus' label='Status'
        value={closureStatus} onChange={onClosureStatusChange} optionList={closureStatusList}
        error={closureStatusError} setError={setClosureStatusError}
      />
    </ModalFormUI>
  )
}

export default LoanChequeUpdateModalUI